import axios from "axios";
import jwt_decode from "jwt-decode";
import { getToken } from "@/utils/login/tokenCheck";
const request = axios.create({
  baseURL:
    // "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/training",
    "https://gateway.hire3x.com/training",
});

function getProcessedToken() {
  var decoded = jwt_decode(getToken());
  return decoded.sub;
}

function getUserName() {
  const decoded = jwt_decode(getToken());
  return decoded.name;
}

request.interceptors.request.use(
  (config) => {
    // config.headers["userID"] = getProcessedToken();
    config.headers["Authorization"] = "Bearer " + getToken();
    return config;
  },
  (error) => {
    return error;
  },
);

request.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return error.response;
  },
);

const assessmentUrl = axios.create({
  baseURL:
    "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/",
});

assessmentUrl.interceptors.request.use(
  (config) => {
    // config.headers["u"] = getUserID();
    config.headers["Authorization"] = "Bearer " + getToken();

    return config;
  },
  (error) => {
    return error;
  },
);

assessmentUrl.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return error.response;
  },
);

export { request, getToken, getProcessedToken, getUserName, assessmentUrl };
